module.exports = __webpack_public_path__ + "media/img/specialize/item12-4999d9f9b91e02316e5ef10f7766a935.svg";